export default function Progress(): JSX.Element {
  return (
    <s-section heading="Set up Smartrr" subheading="We'll shape the steps around your store">
      <s-stack
        alignContent="start"
        direction="inline"
        gap="small"
        justifyContent="space-between"
        padding="small-400"
      >
        <s-stack direction="inline" alignContent="center" gap="small-300">
          <s-badge size="large" tone="success" icon="check"></s-badge>
          <s-text>Connect</s-text>
        </s-stack>

        <s-stack direction="inline" alignContent="center" gap="small-300">
          <s-badge size="large" tone="success" color="strong">
            2
          </s-badge>
          <s-text fontWeight="semibold">Your store</s-text>
        </s-stack>

        <s-stack direction="inline" alignContent="center" gap="small-300">
          <s-badge size="large" tone="neutral">
            3
          </s-badge>
          <s-text>Program</s-text>
        </s-stack>

        <s-stack direction="inline" alignContent="center" gap="small-300">
          <s-badge size="large" tone="neutral">
            4
          </s-badge>
          <s-text>Widget</s-text>
        </s-stack>

        <s-stack direction="inline" alignContent="center" gap="small-300">
          <s-badge size="large" tone="neutral">
            5
          </s-badge>
          <s-text>Portal</s-text>
        </s-stack>
      </s-stack>

      <s-button slot="secondary-actions">Skip for now</s-button>
    </s-section>
  );
}
